import React, { useState, useEffect, memo } from 'react';
import FormularioCargaHora from '../cardCargaDehora/FormularioCargaHora.jsx';
import './carddia.css';
import { useSelector, useDispatch } from 'react-redux';
import { actualizarHorasUsuariologin, eliminarHoras, getTodasTareas} from '../../actions/index.js';
import Modal from 'react-modal';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner.jsx'; // Importa el componente LoadingSpinner
import './../Modal/Modal.css';
import { logger } from '../../utils/logger.js';
import swal from 'sweetalert';
Modal.setAppElement('#root');

function CardDia({ dia, fecha }) {
  // Usa el hook useDispatch para obtener la función dispatch de Redux
  const dispatch = useDispatch();

  // Define varios estados locales usando el hook useStatev
  const [formularioVisible, setFormularioVisible] = useState(false);
  const [loading, setLoading] = useState(true); // Estado para controlar la carga
  const tareas = useSelector(state => state.tareas || []);
  const clientes = useSelector(state => state.clientes || []);
  const tareasDefault = useSelector(state => state.tareasDefault);
 // const usuario = useSelector(state => state.session);
  const horasLocalStorage = useSelector(state => state.horas || []);
  const [horasEditando, setHorasEditando] = useState({});
  const [idHorasEditando, setIdHorasEditando] = useState(null);
  const [datosDuplicar, setDatosDuplicar] = useState(null); // datos para duplicar una entrada

  // Logging para diagnóstico
  useEffect(() => {
    if (Array.isArray(horasLocalStorage)) {
      const horasDeEsteFecha = horasLocalStorage.filter(hora => hora.fechaCarga === fecha);
      if (process.env.NODE_ENV === 'development') {
        logger.log(`CardDia ${fecha}: Total horas en Redux: ${horasLocalStorage.length}, Horas de esta fecha: ${horasDeEsteFecha.length}`);
        if (horasDeEsteFecha.length > 0) {
          logger.log(`Horas encontradas para ${fecha}:`, horasDeEsteFecha);
        }
      }
    }
  }, [horasLocalStorage, fecha]);


// Realiza algunas operaciones para obtener la fecha actual y la fecha de la tarjeta
const [diaFecha, mes, ano] = fecha.split('/');
const fechaTarjeta = new Date(ano, mes - 1, diaFecha);
const fechaActual = new Date();
const horasHabilitadas = useSelector(state => state.horasHabilitadas);
// Calcular mes y año actual
const mesActual = fechaActual.getMonth();
const anoActual = fechaActual.getFullYear();

// Calcular los últimos 3 meses (incluido el actual)
const fechasPermitidas = [];
for (let i = 0; i < 3; i++) {
  const fechaPermitida = new Date(anoActual, mesActual - i, 1);
  fechasPermitidas.push({
    mes: fechaPermitida.getMonth(),
    ano: fechaPermitida.getFullYear()
  });
}

// Verificar si la fecha de la tarjeta está en los últimos 3 meses
const esUltimosTresMeses = fechasPermitidas.some(fp => 
  fechaTarjeta.getMonth() === fp.mes && fechaTarjeta.getFullYear() === fp.ano
);

// Si las horas están habilitadas, se puede cargar en cualquier fecha
// Si están deshabilitadas, solo en los últimos 3 meses
const puedeCargarHoras = horasHabilitadas || esUltimosTresMeses;

// ¿La tarjeta corresponde al día de hoy? (para resaltarla)
const esHoy =
  fechaTarjeta.getDate() === fechaActual.getDate() &&
  fechaTarjeta.getMonth() === fechaActual.getMonth() &&
  fechaTarjeta.getFullYear() === fechaActual.getFullYear();

// Horas cargadas en este día y su total
const horasDelDia = Array.isArray(horasLocalStorage)
  ? horasLocalStorage.filter(hora => hora.fechaCarga === fecha)
  : [];
const totalHoras = Math.round(horasDelDia.reduce((total, hora) => total + Number(hora.horas), 0) * 100) / 100;

// Horas ya cargadas en el día EXCLUYENDO la entrada que se está editando
// (se usa para validar el tope diario al cargar/actualizar)
const horasOtrasDelDia = idHorasEditando
  ? horasDelDia.filter(hora => hora.id !== idHorasEditando).reduce((total, hora) => total + Number(hora.horas || 0), 0)
  : totalHoras;

// Debug logging para verificar la lógica de habilitación
if (process.env.NODE_ENV === 'development') {
  logger.log(`CardDia Debug - Fecha: ${fecha}`);
  logger.log(`  - horasHabilitadas: ${horasHabilitadas}`);
  logger.log(`  - esUltimosTresMeses: ${esUltimosTresMeses}`);
  logger.log(`  - puedeCargarHoras: ${puedeCargarHoras}`);
  logger.log(`  - Mes de tarjeta: ${fechaTarjeta.getMonth() + 1}/${fechaTarjeta.getFullYear()}`);
  logger.log(`  - Fechas permitidas:`, fechasPermitidas.map(fp => `${fp.mes + 1}/${fp.ano}`));
}
// Usa el hook useEffect para realizar una acción cuando el componente se monta
useEffect(() => {
    const fetchTareas = async () => {
      try {
        setLoading(true); // Establecer loading en true antes de iniciar la carga de datos
        //await dispatch(getTodasTareas());// Cargar tareas para mostrar en el formulario
        if(tareas.length >= 0){
          setLoading(false); // Establecer loading en false después de cargar los datos
        }
      } catch (error) {
        logger.error('Error al cargar datos iniciales:', error);
        setLoading(false); // Establecer loading en false en caso de un error
      }
    };
  
    fetchTareas();
  
    return () => {
      logger.log('CardDia component unmounted');
    };
  }, [dispatch, tareas.length]);

//funcion para editar horas
const handleEditar = (horasParaEditar) => {
    setDatosDuplicar(null);
    setHorasEditando(prevHorasEditando => ({
      ...prevHorasEditando,
      [horasParaEditar.id]: horasParaEditar
    }));// Guardar las horas a editar en el estado local
    setIdHorasEditando(horasParaEditar.id);
    setFormularioVisible(true);
  };

//funcion para duplicar una entrada (abre el modal precargado como NUEVO registro en el mismo día)
const handleDuplicar = (horaParaDuplicar) => {
    setHorasEditando({});
    setIdHorasEditando(null);
    setDatosDuplicar(horaParaDuplicar);
    setFormularioVisible(true);
  };

// en las cards de los dias se muestran las horas cargadas en el dia
  const handleCargarHoras = async (horasParaCargar) => {
    try {
      const nuevasHorasCargadas = [...horasLocalStorage, horasParaCargar];
    
      // Actualizar horas en el estado global
      await dispatch(actualizarHorasUsuariologin(fecha, nuevasHorasCargadas));
    
      setFormularioVisible(false);
      setHorasEditando(prevHorasEditando => {
        const newHorasEditando = { ...prevHorasEditando };
        delete newHorasEditando[horasParaCargar.id];
        return newHorasEditando;
        
      });
      setLoading(true);
      await dispatch(getTodasTareas()); // Forzar la actualización de los datos
      setLoading(false); // sin delay artificial: apenas terminan las tareas se oculta el spinner
    } catch (error) {
      logger.error('Error en handleClick:', error);
      setLoading(false); // Establecer loading en false en caso de un error
    }
  };

//funcion para cerrar el modal
  const handleClose = () => {
    setFormularioVisible(false);
    setHorasEditando({});
    setIdHorasEditando(null);
    setDatosDuplicar(null);
  };

//funcion para eliminar horas
const handleEliminar = async (idParaEliminar) => {
    // Confirmación antes de eliminar
    swal({
      className: "textoAlerta",
      title: "¿Desea eliminar este registro?",
      buttons: {
        cancel: {
          text: "Cancelar",
          value: null,
          visible: true,
          className: "alertaBtn1", // Aquí puedes agregar una clase para estilizar el botón
          closeModal: true,
        },
        confirm: {
          text: "Si, eliminar",
          value: true,
          visible: true,
          className: "alertaBtn2", // Aquí puedes agregar una clase para estilizar el botón
          closeModal: true
        }
      },
     
    })
    .then(async (willDelete) => {
      if (willDelete) {
        setLoading(true); // Establecer loading en true antes de iniciar la eliminación
        await dispatch(eliminarHoras(idParaEliminar));
        const nuevasHorasCargadas = horasLocalStorage.filter(horas => horas.id !== idParaEliminar);
        await dispatch(actualizarHorasUsuariologin(fecha, nuevasHorasCargadas));
        setLoading(false); // sin delay artificial
      }
    });
  };

 /* const handleFormSubmit = () => {
    setLoading(true); // Cambia el estado de carga a true cuando se envía el formulario
  };
*/
  return (
    <div className={`carddia${esHoy ? ' carddia--hoy' : ''}`}>
      <div className="carddia__head">
        <span className="carddia__dia">
          {dia}
          {esHoy && <span className="carddia__hoy">HOY</span>}
        </span>
        <span className="carddia__fecha">{fecha}</span>
      </div>
      {loading
      ? (

        <LoadingSpinner /> // Muestra el indicador de carga mientras los datos se están cargando
      ) : (
        // Si los datos ya se han cargado, muestra el contenido
        <>
          <div className="carddia__total">
            <span className={totalHoras > 0 ? 'chipHoras chipHoras--activo' : 'chipHoras'}>
              {totalHoras} hs
            </span>
          </div>
          <button
            className='BotonAgregarHora'
            onClick={() => setFormularioVisible(true)}
            disabled={!puedeCargarHoras}
            title={!puedeCargarHoras ? 'Período cerrado. Pedí a un administrador que habilite la carga de horas.' : undefined}
          >
            + Agregar
          </button>
          {!puedeCargarHoras && (
            <p className="carddia__cerrado">Período cerrado · pedí habilitación a un admin</p>
          )}
          <div className="carddia__entries">
            {horasDelDia.length > 0 ? (
              horasDelDia.map((hora, index) => {
                 // Busca la tarea, el cliente y la tarea por defecto correspondientes a la hora
                const tarea = tareas.find(t => t && t && t.id === hora.tareaId);
                const cliente = clientes.find(c => c && c && c.id === hora.clienteId);
                const tareaDefault = tareasDefault.find(td => td.id === hora.tareaId);
                  // Obtiene los nombres de la tarea, el cliente y la tarea por defecto
                const nombreTarea = tarea?.nombre;
                const nombreCliente = cliente?.nombre;
                const nombreTareaDefault = tareaDefault?.nombre;
                const nombreTareaFinal = nombreTarea ? nombreTarea : nombreTareaDefault;
                // Si hay cliente, va de título y la tarea de subtítulo; si no, la tarea es el título
                const titulo = nombreCliente ? nombreCliente : nombreTareaFinal;
                const subtitulo = nombreCliente ? nombreTareaFinal : null;
                // Muestra los detalles de la hora
                return (
                  <div className="horaItem" key={index}>
                    <div className="horaItem__top">
                      <span className="horaItem__titulo">{titulo}</span>
                      <span className="horaItem__horas">{hora.horas} hs</span>
                    </div>
                    {subtitulo && <div className="horaItem__sub">{subtitulo}</div>}
                    <div className="horaItem__acciones">
                      <button
                        className='btnDup'
                        onClick={() => handleDuplicar(hora)}
                        disabled={!puedeCargarHoras}
                        title="Duplicar"
                      >
                        Duplicar
                      </button>
                      <button
                        className='btnEdit'
                        onClick={() => { handleClose(); handleEditar(hora); }}
                        disabled={!puedeCargarHoras}
                      >
                        Editar
                      </button>
                      <button
                        className="btnElim"
                        onClick={() => handleEliminar(hora.id)}
                        disabled={!puedeCargarHoras}
                      >
                        Eliminar
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
                // Si no hay horas en el almacenamiento local para el día, muestra un mensaje
              <p className='nohayhoras'>Sin horas cargadas</p>
            )}
          </div>

          <Modal
            isOpen={formularioVisible}
            onRequestClose={handleClose}
            className="FormModal__content"
            overlayClassName="FormModal__overlay"
          >
            <FormularioCargaHora
              onSubmit={handleCargarHoras}
              onClose={handleClose}
              horas={horasEditando[idHorasEditando]}
              isEditing={!!horasEditando[idHorasEditando] || !!datosDuplicar}
              fecha={fecha}
              totalHorasDiaPrevio={horasOtrasDelDia}
              duplicarDe={datosDuplicar}
            />
          </Modal>

        </>
      )}
    </div>
  );
}

export default memo(CardDia);